/**
 * @generated SignedSource<<523df3aad1eacafacc1ec3ead25e3d03>>
 * @relayHash 78dd52a66a3b3b39cb7190c249d4f465
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ad71a3cca195b272bd2701ca0eac659d1d15aebe82897c1d52f186d034727ab6

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceTrackType = "BRIEFING" | "NARRATION" | "%future added value";
export type PlaylistQuery$variables = {
  cloudId: string;
};
export type PlaylistQuery$data = {
  readonly confluence_getPlaylist: {
    readonly tracks: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly mainContent: {
          readonly history: {
            readonly createdBy: {
              readonly displayName: string | null | undefined;
              readonly profilePicture: {
                readonly path: string;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly id: string | null | undefined;
          readonly properties: {
            readonly nodes: ReadonlyArray<{
              readonly value: string | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly space: {
            readonly key: string | null | undefined;
          } | null | undefined;
          readonly status: string | null | undefined;
          readonly subType: string | null | undefined;
          readonly title: string | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly mainSource: string;
        readonly supportingSources: ReadonlyArray<string> | null | undefined;
        readonly type: ConfluenceTrackType;
      }>;
    };
  } | null | undefined;
};
export type PlaylistQuery = {
  response: PlaylistQuery$data;
  variables: PlaylistQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "type"
},
v4 = {
  "kind": "ScalarField",
  "name": "mainSource"
},
v5 = {
  "kind": "ScalarField",
  "name": "title"
},
v6 = {
  "kind": "ScalarField",
  "name": "status"
},
v7 = {
  "kind": "ScalarField",
  "name": "subType"
},
v8 = {
  "kind": "ScalarField",
  "name": "key"
},
v9 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v10 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v11 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\"])"
},
v12 = {
  "kind": "ScalarField",
  "name": "supportingSources"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PlaylistQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluencePlaylist",
        "kind": "LinkedField",
        "name": "confluence_getPlaylist",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluencePaginatedTracks",
            "kind": "LinkedField",
            "name": "tracks",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConfluenceTrack",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "mainContent",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              (v10/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v11/*: any*/)
                    ]
                  },
                  (v12/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlaylistQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluencePlaylist",
        "kind": "LinkedField",
        "name": "confluence_getPlaylist",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluencePaginatedTracks",
            "kind": "LinkedField",
            "name": "tracks",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConfluenceTrack",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "mainContent",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v5/*: any*/),
                      (v3/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              (v9/*: any*/),
                              (v10/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v11/*: any*/)
                    ]
                  },
                  (v12/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ad71a3cca195b272bd2701ca0eac659d1d15aebe82897c1d52f186d034727ab6",
    "metadata": {},
    "name": "PlaylistQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ebc2786920f1ae819b4380b71e692a3f";

export default node;
